module.exports = __webpack_public_path__ + "static/media/ergoapp2.a76523b2.png";